import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './reservedCapacity.module.scss';

type Props = {}

const ReservedCapacityElectricityDraftYearlyHeader = (props: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // sub-renders
  const renderUnit = () => {
    return <small>[MW]</small>;  
  }

  // render
  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold px-2 px-sm-3">
      <div className="row no-gutters align-items-end">
        <div className={`col-sm-auto ${styles.periodCol} font-weight-bold`}>
          {tLabels("reservedCapacityElectricityHeader.timePeriod")} 
        </div>
        <div className="col-sm text-center">
          <span className="d-lg-none">{tLabels("reservedCapacityElectricityHeader.power")}</span>
          <span className="d-none d-lg-inline">{tLabels("reservedCapacityElectricityHeader.reservedPower")}</span> {renderUnit()}
        </div>
        <div className="col-sm text-center">
          {tLabels("reservedCapacityElectricityHeader.yearly")} <span className="d-none d-xl-inline"> {tLabels("reservedCapacityElectricityHeader.capacity")}</span> {renderUnit()}
        </div>
        <div className={`col-sm-auto text-right ${styles.typeCol}`}>
          {tLabels("reservedCapacityElectricityHeader.state")}
        </div>
      </div>
    </div>
  )
}

export default ReservedCapacityElectricityDraftYearlyHeader;